import { AxiosRequestConfig } from 'axios';
import { z } from 'zod';
import { HttpConnection } from './http-connection';
import { FileResponse } from '~/app-modules/core/clients/dto/file-response';

@singleton()
export class NotAuthorizedClient {
  constructor(protected connection: HttpConnection) {
    ensureInstanceOf(HttpConnection, { connection });
  }

  protected async executeRequest<T>(
    options: AxiosRequestConfig,
    deserializer: z.Schema<T> = z.optional(z.any()),
  ): Promise<T> {
    const _result = await this.connection.executeRequest(options);
    return deserializer.parse(_result);
  }

  protected downloadFile(options: AxiosRequestConfig): Promise<FileResponse> {
    return this.connection.downloadFile(options);
  }
}
